// Pass the whole subject ('V4 site' vs 'site') so a V3 failure is never reported as V4.
// validation_errors win: V4's generic invalid_request_body isn't actionable alone.
export function formatApiError(verb, subject, e) {
  const data = e?.response?.data;
  const status = e?.response?.status;
  const suffix = status ? ` (HTTP ${status})` : '';
  const fields = Array.isArray(data?.validation_errors)
    ? data.validation_errors.join(', ')
    : null;
  const detail = fields || data?.message || data?.error || e?.message || 'unknown error';
  return `Failed to ${verb} ${subject}: ${detail}${suffix}`;
}
